import "react-toastify/dist/ReactToastify.css";
import "../Inspection.css";
import { VesselInformation } from "../components/VesselInformation";
import { DownloadAndShare } from "../components/DownloadAndShare";
import { Tabs } from "../components/tab-bar/Tabs";
import { useTranslation } from "react-i18next";
import { getVesselInspectionData } from "../queries/particularsQueries";
import { useParams } from "react-router-dom";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { InspectionViewType } from "../types/InspectionViewType";
import { getTabsForInspection } from "./InspectionTabs";
import { VesselsValueOptIn } from "@idwal/idwal-react-components";
import { checkIfIdUser } from "../utils/userGroups";
import { useEffect, useState } from "react";
import { InspectionSideBar } from "./InspectionSideBar";
import { updateOptIn } from "../services/InspectionService";
import { useAppDispatch } from "../redux/hooks";
import { setSelectedInspection } from "../features/inspectionsSlice";
import { getDownloads } from "../queries/downloadQueries";

export const RESALE_REPORT_SHORT_NAME = "PSR";

export default function Inspection(props: { readonly view?: InspectionViewType}) {
    const [sideBarOpen, setSideBarOpen] = useState(false);
    const [displayVesselsValueOptIn, setDisplayVesselsValueOptIn] = useState(false);
    const { t } = useTranslation("locale");
    const { inspectionId } = useParams();
    const { user } = useAuthenticator((context) => [
        context.authStatus,
        context.user
    ]);

    const { data, isError, isLoading, error } = getVesselInspectionData(
        inspectionId!,
        user,
    );

    const { data: documentData } = getDownloads(inspectionId ?? "", user);

    const dispatch = useAppDispatch();

    const isResaleReport = data?.InspectionTypeShortName.toUpperCase() === RESALE_REPORT_SHORT_NAME.toUpperCase();

    useEffect(() => {
        if (data) {
            dispatch(setSelectedInspection(data.inspectionNumber));
            setDisplayVesselsValueOptIn(
                data.displayVesselValueOptIn &&
                !data.earlyRelease &&
                !isResaleReport &&
                !!data.Grade
            )
        }
    }, [data]);

    const isIdUser = checkIfIdUser(user);

    return (
        <div className={'inspection-page-wrapper'}>
            <div>
                <VesselsValueOptIn
                    agreeCallback={() => {
                        setDisplayVesselsValueOptIn(false);
                        updateOptIn(inspectionId!, "True", user);
                    }}
                    declineCallback={() => {
                        setDisplayVesselsValueOptIn(false);
                        updateOptIn(inspectionId!, "False", user);
                    }}
                    visible={displayVesselsValueOptIn}
                ></VesselsValueOptIn>

                <VesselInformation />
                <div className="relative mt-6">
                    <div className="z-1 download-button-responsive flex justify-content-center">
                        <DownloadAndShare 
                            data={data}
                        />
                    </div>
                    <div className="mt-3 z-0">
                        <Tabs selectedTab={props.view} tabs={getTabsForInspection({
                            vesselInspectionResponse: data,
                            isError: isError,
                            isLoading: isLoading,
                            error: error
                        }, documentData, t)}></Tabs>
                    </div>
                </div>
            </div>
            <InspectionSideBar
                sideBarOpen={sideBarOpen}
                setSideBarOpen={setSideBarOpen}
                inspectionType={data?.InspectionType}
                isIdUser={isIdUser}
            />
        </div>
    );
}
